import { render, staticRenderFns } from "./other-list.vue?vue&type=template&id=131e1263&scoped=true"
import script from "./other-list.vue?vue&type=script&lang=js"
export * from "./other-list.vue?vue&type=script&lang=js"
import style0 from "./other-list.vue?vue&type=style&index=0&id=131e1263&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131e1263",
  null
  
)

export default component.exports